import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

// Import Components
import { withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import DnccMonitorApp from './pages/DnccMonitorApp'
import Login from './pages/Login'

// Import Styles
import './App.css'

// Import Actions & Methods
import { tokenValidation } from './store/actions/authActions'

class App extends React.PureComponent {
  state = {
    isAuthenticated: false,
    isLoading: true
  }

  componentDidMount() {
    // Check If login token still valid
    const token = localStorage.getItem('token')

    if(token) {
      this.setState({ isLoading: true })

      // Validate Token
      tokenValidation(token)
        .then(isAuthenticated => {
          this.setState({ isAuthenticated, isLoading: false })
        })
        .catch(err => {
          console.error(err)
          this.setState({ isAuthenticated: false, isLoading: false })
        })

    } else {
      this.setState({ isAuthenticated: false, isLoading: false })
    }
  }

  render() {
    const { isAuthenticated, isLoading } = this.state
    const token = localStorage.getItem('token')

    return (
      <Box { ...appContainerStyles }>
        <BrowserRouter>
          <Switch>
            <Route exact path='/'>
              {
                token && isAuthenticated && !isLoading ?
                <DnccMonitorApp /> :
                isLoading ?
                <StyledCircularProgress /> :
                <Redirect to='/login' />
              }
            </Route>

            <Route exact path='/login'>
              {
                token && isAuthenticated && !isLoading ?
                <Redirect to='/' /> :
                isLoading ?
                <StyledCircularProgress /> :
                <Login />
              }
            </Route>
          </Switch>
        </BrowserRouter>
      </Box>
    )
  }
}

// Styled Components
const StyledCircularProgress = withStyles({
  colorPrimary: {
    color: 'rgb(45, 219, 172, 1)'
  }
})(CircularProgress)

// JSS Styles
const appContainerStyles = {
  margin: 0,
  padding: 0,
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden'
}

export default App